module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7691e0682d3855f163ceee281d61e23b.png";